import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import {PlateMapType} from 'samples/plate-maps/annotate-fill-plate-modal/AnnotateFillPlateModalConstants';
import {FillPlateStructuredTableItemsQuery} from 'samples/plate-maps/fill-from-structured-table-modal/__generated/FillPlateStructuredTableItemsQuery';
import {
  AccessibleStructuredTableItemNode,
  getAdditionalTableColumns,
  StructuredTableItemNode,
  validateFillPlateListItem,
} from 'samples/plate-maps/fill-plate-modal/FillPlateFromModalUtils';
import {ProcedureTestOrderConfig} from 'samples/plate-maps/integrations/procedures/PlateMapTestOrderUtils';
import {SelectableItemsTable} from 'worklists/SelectItemsFromListView';

interface FillPlateFromStructuredTableResultsProps {
  destinationPlateId: string | null;
  result: FillPlateStructuredTableItemsQuery;
  selectedItems: Array<AccessibleStructuredTableItemNode>;
  setSelectedItems: (newSelectedItems: Array<AccessibleStructuredTableItemNode>) => void;
  /** Procedure config to validate test orders within assay context */
  procedureTestOrderConfig: ProcedureTestOrderConfig | null;
  plateMapType: PlateMapType;
}

export default function FillPlateFromStructuredTableResults({
  destinationPlateId,
  result,
  selectedItems,
  setSelectedItems,
  procedureTestOrderConfig,
  plateMapType,
}: FillPlateFromStructuredTableResultsProps): JSX.Element {
  // Don't create a new array each render in order to avoid an infinite re-render from SelectableItemsTable's
  // autoselection useEffect.
  const items = useMemo(() => [...result.bioentities, ...result.containers], [result]);
  const additionalColumns = useMemo(() => getAdditionalTableColumns(), []);
  return (
    <div className={css(styles.listWrapper)}>
      <SelectableItemsTable<StructuredTableItemNode>
        items={items}
        selectedItems={selectedItems}
        // The table should prevent selection of disabled items
        setSelectedItems={(newSelectedItems) => {
          setSelectedItems(newSelectedItems as Array<AccessibleStructuredTableItemNode>);
        }}
        validateItem={(listItemNode: StructuredTableItemNode) =>
          validateFillPlateListItem({
            listItemNode,
            destinationPlateId,
            procedureTestOrderConfig,
            plateMapType,
          })
        }
        additionalColumns={additionalColumns}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  listWrapper: {
    marginTop: '16px',
  },
});
